import type { ActionFlowReviewDialogs } from '@/components/ActionFlow/useActionFlowReview'

import {
  VaultV2DepositActionFlowReviewDialog,
  type VaultV2DepositActionFlowReviewDialogProps
} from './VaultV2DepositActionFlowReviewDialog'
import VaultV2DepositReviewDialog from './VaultV2DepositReviewDialog'

type VaultV2DepositReviewInput = Omit<VaultV2DepositActionFlowReviewDialogProps, 'onExit'>

export const vaultV2DepositReviewDialogs: ActionFlowReviewDialogs<VaultV2DepositReviewInput> = {
  ActionFlowDialog: VaultV2DepositActionFlowReviewDialog,
  renderLegacy: input => (
    <VaultV2DepositReviewDialog
      {...input}
      onTxSuccess={() => {
        input.onTxSuccess()
        void input.refetchPosition()
      }}
    />
  )
}
